import { api } from "../api";
import { ApiPaths } from "../api/paths";
import { GetChatBotMessageResponce } from "./chat.service.d";

export class ChatService {
    /**
     * Sign in request
     *
     * @param  message {String}
     */
    static async askToBot(message: string): Promise<GetChatBotMessageResponce> {
        return api.post(ApiPaths.SEND_BOT_MESSAGE, {
            message,
        });
    }
}
